import React from 'react';
import PropTypes from 'prop-types';

import { getCurrencyFormatProp } from '_core/utils/getCurrencyFormatProp';
import { useCartContext } from '_core/contexts/Cart';
import { FormattedInputBase } from '_core/components/FormattedInputBase';

export const PriceInput = (props) => {
  const {
    onChange,
    currency,

    ...rest
  } = props;

  delete rest.setFieldValue; // ?
  delete rest.setFieldTouched; // ?

  const cart = useCartContext();

  return (
    <FormattedInputBase
      onChange={onChange}
      {...getCurrencyFormatProp(cart.findCurrency(currency))}
      {...rest}
    />
  );
};

PriceInput.defaultProps = {};

PriceInput.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  success: PropTypes.bool,
  helperText: PropTypes.node,
  label: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  currency: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
